<template>
    <!-- results number and sort filter -->
    <section
        id="resultRow"
        class="responsiveSection resultRow">
        <div class="responsiveSection__grid gridBox">
            <div class="search__grid search__gridHeadlineRow">
                <!-- Mobile-only filter-toggle and search result indicator -->
                <div class="flex flex__justifyContent--spaceBetween search__grid--left">
                    <div class="flex">
                        <span class="hideOnMobile">
                            <span class="flex flex__alignItems--center headline__totalResult headline__totalResult--bold">
                                {{ trans('TOTAL_RESULTS').toUpperCase() }}:
                            </span>
                        </span>
                        <span class="flex flex__alignItems--center headline__totalResult">{{ numberFormat(totalFound) }} {{ trans('RESULTS') }}</span>
                    </div>
                    <div
                        id="searchOptions"
                        class="flex flex__justifyContent--end sortBox search__grid--middle hideOnMobile">
                        <CustomDropdown
                            id="inlineDropdown__sort"
                            data-gtm="searchResults--sort"
                            :default="sortOptions[0]"
                            element="sort"
                            :value="sortOption"
                            :options="sortOptions"
                            @changeValue="selectSort" />
                    </div>
                </div>
                <button
                    type="button"
                    data-gtm="search__expertSearch--mobile"
                    class="searchbar__expert--mobile button search__grid--right moreFilters hideOnDesktop"
                    aria-label="Expert search"
                    @click="updateShowSidebar(true)">
                    <span class="moreFilters--mobile display-flex">
                        {{ trans('FORM_FILTER') }}
                        <span
                            v-if="selectedFilterNumber > 0"
                            class="margin-left-5">
                            ({{ selectedFilterNumber }})
                        </span>
                        <svg
                            height="16"
                            width="16"
                            aria-hidden="true">
                            <use href="#iconDisplayOptionsRegular" />
                        </svg>
                    </span>
                </button>
                <div class="search__grid--right flex flex__alignItems--center hideOnMobile">
                    <p class="headline__search">
                        {{ trans('REFINE_YOUR_SEARCH') }}
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import CustomDropdown from './components/searchDropdown.vue';
    import { isMobile } from '../tools/isMobile';
    import { computed, ref } from 'vue';
    import Translator from 'tools/trans';
    import { useActions, useGetters } from '../composables/useVuex';
    import { mapState, mapMutations } from 'vuex';
    import { numberFormat } from '../tools/numberFormat';
    import { defaultLanguageValue } from './store/search.module';
    const ID_RELEVANCE_VALUE = 'idrelevance';
    const PUBLICATION_DATE_VALUE = 'publicationDate';
    const AND_VALUE = 'and';
    const DE_LOCALE = 'de';
    const EN_LOCALE = 'en';
    const REGIONAL_BOOST_DEACTIVATED_VALUE = '1';
    const ZERO_VALUE = '0';
    const PARAM_OBJECT = {
        INTERVAL: 'interval',
        REGIONAL_BOOST: 'isRegionPref',
        CONTENT_TYPE: 'tabGroup',
        ACCURACY: 'accuracy',
        COUNTRY: 'isoregion',
        LOCATION: 'region[]',
        CATEGORY: 'category[]',
        LANGUAGE: 'language',
        ARCHIVE: 'idRelevance',
    };
    export default {
        name: 'SearchHeadline',
        components: {
            CustomDropdown,
        },
        data() {
            return {
                isMobile: isMobile(),
                showDropdown: !isMobile(),
                modalStyle: 'position: absolute; z-index: 9;',
            };
        },
        computed: {
            ...mapState('search', ['selectedFilterNumber']),
            /* eslint-enable */
            hideFocusFilter() {
                return this.sortOption !== ID_RELEVANCE_VALUE;
            },
            localeEnDe() {
                return window.stGlobals.locale === DE_LOCALE ?? EN_LOCALE;
            },
        },
        watch: {
            resetFilterClicked() {
                this.updateFilteredNumber();
            },
        },
        methods: {
            ...mapMutations('search', ['setSelectedFilterNumber']),
            trans: Translator.trans,
            changeFocus() {
                const resultList = document.querySelector('[data-results]');
                resultList.firstElementChild.focus();
            },
            updateFilteredNumber() {
                const queryString = window.location.search;
                const uparams = new URLSearchParams(queryString);

                let numberOfSelectedFilters = 0;
                if (uparams) {
                    if (uparams.get(PARAM_OBJECT.INTERVAL) && uparams.get(PARAM_OBJECT.INTERVAL) !== ZERO_VALUE) {
                        numberOfSelectedFilters++;
                    }
                    if (uparams.get(PARAM_OBJECT.CONTENT_TYPE)) {
                        numberOfSelectedFilters = numberOfSelectedFilters + uparams.get(PARAM_OBJECT.CONTENT_TYPE).split(',').length;
                    }
                    if (uparams.get(PARAM_OBJECT.ACCURACY) && uparams.get(PARAM_OBJECT.ACCURACY) !== AND_VALUE) {
                        numberOfSelectedFilters++;
                    }
                    if (uparams.get(PARAM_OBJECT.COUNTRY)) {
                        if (uparams.get(PARAM_OBJECT.COUNTRY) !== ZERO_VALUE) {
                            numberOfSelectedFilters++;
                        } else if (uparams.get(PARAM_OBJECT.LOCATION) && uparams.get(PARAM_OBJECT.LOCATION) !== '') {
                            numberOfSelectedFilters++;
                        }
                    } else if (uparams.get(PARAM_OBJECT.LOCATION) && uparams.get(PARAM_OBJECT.LOCATION) !== '') {
                        numberOfSelectedFilters++;
                    }
                    if (uparams.get(PARAM_OBJECT.ARCHIVE) && uparams.get(PARAM_OBJECT.ARCHIVE) !== ZERO_VALUE) {
                        numberOfSelectedFilters++;
                    }
                    if (uparams.get(PARAM_OBJECT.CATEGORY) && uparams.get(PARAM_OBJECT.CATEGORY) !== ZERO_VALUE) {
                        numberOfSelectedFilters++;
                    }
                    if (uparams.get(PARAM_OBJECT.LANGUAGE) && uparams.get(PARAM_OBJECT.LANGUAGE) !== defaultLanguageValue[window.stGlobals.locale]) {
                        numberOfSelectedFilters++;
                    }
                }
                this.filterNumbers = numberOfSelectedFilters;
            },
        },
        mounted() {
            this.updateFilteredNumber();
            this.setSelectedFilterNumber(this.filterNumbers);
        },
        setup() {
            const filterNumbers = ref(0);
            const sortOptions = [
                { value: ID_RELEVANCE_VALUE, name: Translator.trans('FORM_SEARCH_RELEVANCE') },
                { value: PUBLICATION_DATE_VALUE, name: Translator.trans('FORM_SEARCH_DATE') },
                // { value: 'popularity', name: trans('FORM_SEARCH_POPULARITY') },
            ];
            const searchForm = ref(null),
                  sortOption = computed(() => {
                      return getters.sort.value || ID_RELEVANCE_VALUE;
                  }),
                  filterOption = computed(() => {
                      return getters.focus.value || REGIONAL_BOOST_DEACTIVATED_VALUE;
                  });
            const getters = {
                ...useGetters('search', [
                    'resultCount',
                    'sort',
                    'focus',
                    'totalFound',
                    'resetFilterClicked',
                    'applyFilterClicked',
                ]),
            };
            const showSidebar = getters.getShowSidebar;
            const actions = {
                ...useActions('search', [
                    'setSort',
                    'setFocus',
                    'updateShowSidebar',
                    'resetPageNumber',
                ]),
            };
            async function updateFilteredNumber() {
                const queryString = window.location.search;
                const uparams = new URLSearchParams(queryString);

                let numberOfSelectedFilters = 0;
                if (uparams) {
                    if (uparams.get(PARAM_OBJECT.INTERVAL) && uparams.get(PARAM_OBJECT.INTERVAL) !== ZERO_VALUE) {
                        numberOfSelectedFilters++;
                    }
                    if (uparams.get(PARAM_OBJECT.CONTENT_TYPE)) {
                        numberOfSelectedFilters = numberOfSelectedFilters + uparams.get(PARAM_OBJECT.CONTENT_TYPE).split(',').length;
                    }
                    if (uparams.get(PARAM_OBJECT.ACCURACY) && uparams.get(PARAM_OBJECT.ACCURACY) !== AND_VALUE) {
                        numberOfSelectedFilters++;
                    }
                    if (uparams.get(PARAM_OBJECT.COUNTRY)) {
                        if (uparams.get(PARAM_OBJECT.COUNTRY) !== ZERO_VALUE) {
                            numberOfSelectedFilters++;
                        } else if (uparams.get(PARAM_OBJECT.LOCATION) && uparams.get(PARAM_OBJECT.LOCATION) !== '') {
                            numberOfSelectedFilters++;
                        }
                    } else if (uparams.get(PARAM_OBJECT.LOCATION) && uparams.get(PARAM_OBJECT.LOCATION) !== '') {
                        numberOfSelectedFilters++;
                    }
                    if (uparams.get(PARAM_OBJECT.ARCHIVE) && uparams.get(PARAM_OBJECT.ARCHIVE) !== ZERO_VALUE) {
                        numberOfSelectedFilters++;
                    }
                    if (uparams.get(PARAM_OBJECT.CATEGORY) && uparams.get(PARAM_OBJECT.CATEGORY) !== ZERO_VALUE) {
                        numberOfSelectedFilters++;
                    }
                    if (uparams.get(PARAM_OBJECT.LANGUAGE) && uparams.get(PARAM_OBJECT.LANGUAGE) !== defaultLanguageValue[window.stGlobals.locale]) {
                        numberOfSelectedFilters++;
                    }
                }

                filterNumbers.value = numberOfSelectedFilters;
            }
            async function selectFilter(option) {
                await actions.resetPageNumber();
                actions.setFocus(option);
            }
            async function selectSort(option) {
                await actions.resetPageNumber();
                actions.setSort(option);
            }
            async function updateShowSidebar(value) {
                if (value) {
                    document.querySelector('body').addEventListener('click', function(e) {
                        const anchor = e.target.closest('header');
                        if (anchor !== null) {
                            actions.updateShowSidebar(false);
                        }
                    }, false);
                } else {
                    document.querySelector('body').removeEventListener('click', function(e) {
                        const anchor = e.target.closest('header');
                        if (anchor !== null) {
                            actions.updateShowSidebar(false);
                        }
                    }, false);
                }
                await actions.updateShowSidebar(value);
                await updateFilteredNumber();
            }

            return {
                showSidebar,
                searchForm,
                sortOption,
                filterOption,
                selectFilter,
                numberFormat,
                sortOptions,
                updateShowSidebar,
                selectSort,
                filterNumbers,
                ...getters,
            };
        },
    };
</script>
